export default "__VITE_ASSET__CipYR6Oy__"